// extracted by mini-css-extract-plugin
export default {"post":"Post_post__N6l6X","link":"Post_link__RQ0Vs"};